<div [class]="theme">
  <div edsGrid>
    <div class="container--wide">
      <ft-intro-section
        [showCta]="content?.cards?.length > 0 ? false : true"
        [content]="content"
        [titleColorTheme]="titleColorTheme"
      ></ft-intro-section>

      <div edsRow>
        <div edsCol>
          <ng-container *ngIf="content?.cards">
            <ul class="list--unstyled index-cards">
              <ng-container *ngFor="let card of content.cards; let last = last">
                <li class="list__item width-full index-cards__item">
                  <eds-card-index-compact
                    edsFlexItem
                    [flexBasis]="0"
                    [flexGrow]="1"
                    [isEdsIcon]="false"
                    [isImg]="true"
                    [imgSrc]="card.imageSrc"
                    [title]="card.title"
                    [isNewWindow]="card.link?.target == '_blank' ? true : false"
                    [externalLink]="card.link?.external"
                    [externalSuffix]="card.link?.externalSuffix"
                    [signInRequired]="
                      card.link?.signInLink | ftIsSignInRequired | async
                    "
                    [hideLockIcon]="card.link?.hideLockIcon"
                    [signInTooltip]="'common.locked-link-tooltip' | translate"
                    [centerAligned]="
                      sectionType === 'index_cards_compact_centered'
                        ? true
                        : false
                    "
                    [href]="card.link?.url"
                    [downloadLocation]="card.link?.downloadLocation"
                    theme="light"
                    [analyticsNoEvent]="true"
                    (linkClick)="setDownloadLocation($event)"
                    [isLastCard]="last"
                  >
                  </eds-card-index-compact>
                </li>
              </ng-container>
            </ul>
          </ng-container>
        </div>
      </div>

      <div edsRow *ngIf="footnote">
        <div edsCol>
          <div
            class="footnote-wrapper"
            edsPadding
            edsPaddingTop="lg"
            [innerHTML]="footnote"
          ></div>
        </div>
      </div>
    </div>
  </div>
</div>
